module.exports = __webpack_public_path__ + "img/tempo_3.146eec20.png";